export const cueUiSchema = {
  "ui:submitButtonOptions": {
    submitText: "Submit",
    norender: true,
  },
  firstName: {},
  lastName: {},
  email: {
    "ui:placeholder": "your.email@example.com",
  },
  phone: {
    "ui:widget": "PhoneWidget",
  },
  companyNameOrGroupNumber: {
    "ui:options": {
      inputProps: {
        style: { backgroundColor: "#f5f5f5" },
      },
    },
  },
  blueSeparator: {
    "ui:field": "blueSeparatorField",
  },
  howCanWeHelp: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5,
      inputProps: {
        style: { backgroundColor: "#f5f5f5" },
      },
    },
  },
  howDidYouHear: {
    "ui:options": {
      inputProps: {
        style: { backgroundColor: "#f5f5f5" },
      },
    },
  },
};
